import { logger } from '@twisto/utils'

import { Headline } from './headline'
import { List } from './list'
import { Paragraph } from './paragraph'
import type { RichTextBlock } from './rich-text.d'

type Props = {
  input?: RichTextBlock[]
  className?: string
  size?: 'small' | 'medium'
}

export const RichText = ({ input, className, size }: Props) => {
  const elements = input?.map((element, index) => {
    const { type, level, children } = element
    if (children.length === 1 && children[0].text === '') {
      return <br key={index} />
    }

    switch (type) {
      case 'heading':
        return (
          <Headline
            key={index}
            className={className}
            content={children}
            level={level}
          />
        )
      case 'paragraph':
        return (
          <Paragraph key={index} className={className} content={children} />
        )
      case 'list':
        return (
          <List
            key={index}
            className={className}
            content={children}
            format={element.format}
            size={size}
          />
        )

      default:
        logger.logError(`Not implemented rich text block type: ${type}`)

        return null
    }
  })

  return <>{elements}</>
}
